// extracted by mini-css-extract-plugin
export default {"titleWrapper":"SwiperTunnelTitle_titleWrapper__+kAVW","image":"SwiperTunnelTitle_image__JT06h"};